var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-body',[_c('h1',[_vm._v("\n      "+_vm._s(_vm.blackTitle)+" "),_c('span',[_vm._v(_vm._s(_vm.blueTitle))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }